var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 2C5.67894 2 4 3.67894 4 5.75V20.2515C4 21.6528 5.56483 22.4855 6.72718 21.7032L10.7436 18.9998C11.5032 18.4885 12.4968 18.4885 13.2564 18.9998L17.2728 21.7032C18.4353 22.4858 20 21.6527 20 20.2515V5.75C20 3.67894 18.3211 2 16.25 2H7.75ZM5.5 5.75C5.5 4.50736 6.50736 3.5 7.75 3.5H16.25C17.4927 3.5 18.5 4.50736 18.5 5.75V20.2515C18.5 20.4517 18.2765 20.5706 18.1104 20.4588L14.094 17.7554C12.828 16.9033 11.172 16.9033 9.90601 17.7554L5.8896 20.4588C5.72345 20.5707 5.5 20.4516 5.5 20.2515V5.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.709c92383eb074232eb30433c20f7114.svg";
export { ForwardRef as ReactComponent };